import { 
  COMMISSIONS_GET_NEW_MONTH_BEGIN, 
  COMMISSIONS_CREATE_NEW_MONTH_BEGIN, 
  COMMISSIONS_UPDATE_COMMISSION_MONTH_BEGIN, 
  COMMISSIONS_GET_RANGE_COMMISSION_MONTH_BEGIN,
  COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_BEGIN,
  COMMISSIONS_GET_STATE_BEGIN,
  COMMISSIONS_GET_PERIOD_BEGIN,
  COMMISSION_POLICY_STATUS_UPDATE_BEGIN,
  COMMISSIONS_GET_POLICY_BEGIN,
} from './constants'

import { takeEvery } from 'redux-saga/effects'
import { getNewCommissionMonthSaga } from './getNewCommissionMonth/saga'
import { postCreateNewMonthlyCommissionSaga } from './createNewCommissionMonth/saga'
import { updateCommissionSaga } from './updateCommissionMonth/saga'
import { getRangeCommissionSaga } from './getRangeCommissionMonth/saga'
import { getPossibleActionsSaga  } from './getPossibleActions/saga'
import { getCommissionsStateSaga } from './getCommissionsStates/saga'
import { getCommissionsPeriodsSaga } from './getCommissionsPeriods/saga'
import { updatePolicyStatusSaga } from './updatePolicyStatus/saga'
import { getPolicySaga } from './getPolicy/saga'
import { getPolicyByIdSaga } from './getPolicyById/saga'

export default function* commissions() {
  yield takeEvery(COMMISSIONS_GET_NEW_MONTH_BEGIN, getNewCommissionMonthSaga)
  yield takeEvery(COMMISSIONS_CREATE_NEW_MONTH_BEGIN , postCreateNewMonthlyCommissionSaga)
  yield takeEvery(COMMISSIONS_GET_STATE_BEGIN, getCommissionsStateSaga)
  yield takeEvery(COMMISSIONS_UPDATE_COMMISSION_MONTH_BEGIN , updateCommissionSaga)
  yield takeEvery(COMMISSIONS_GET_RANGE_COMMISSION_MONTH_BEGIN , getRangeCommissionSaga)
  yield takeEvery(COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_BEGIN, getPossibleActionsSaga)
  yield takeEvery(COMMISSIONS_GET_PERIOD_BEGIN, getCommissionsPeriodsSaga)
  yield takeEvery(COMMISSION_POLICY_STATUS_UPDATE_BEGIN, updatePolicyStatusSaga)
  yield takeEvery(COMMISSIONS_GET_POLICY_BEGIN, getPolicySaga)
  yield takeEvery(COMMISSIONS_GET_POLICY_BEGIN, getPolicyByIdSaga)
}
